
import { useState } from 'react'
import { Badge, tierConfig } from '../../mocks/badges'

interface UserBadgeProps {
  badge: Badge
  size?: 'sm' | 'md' | 'lg'
  locked?: boolean
  showTooltip?: boolean
}

export const UserBadge = ({ badge, size = 'md', locked = false, showTooltip = true }: UserBadgeProps) => {
  const [hovered, setHovered] = useState(false)
  const tier = tierConfig[badge.tier]

  const sizeClasses = {
    sm: 'w-8 h-8',
    md: 'w-11 h-11',
    lg: 'w-14 h-14',
  }

  const iconSizes = {
    sm: 'text-sm',
    md: 'text-lg',
    lg: 'text-xl',
  }

  return (
    <div
      className="relative inline-block"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <div
        className={`${sizeClasses[size]} rounded-xl border-2 flex items-center justify-center transition-all duration-200 cursor-pointer ${
          locked
            ? 'bg-gray-100 border-gray-200 opacity-40 grayscale'
            : `${badge.bgColor} ${badge.borderColor} hover:scale-110 hover:shadow-md`
        }`}
      >
        <i className={`${badge.icon} ${iconSizes[size]} ${locked ? 'text-gray-400' : badge.color}`}></i>
      </div>

      {showTooltip && hovered && (
        <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 z-50 pointer-events-none">
          <div className="bg-gray-900 text-white rounded-lg px-3 py-2 text-xs whitespace-nowrap shadow-lg">
            <p className="font-semibold mb-0.5">{badge.name}</p>
            <p className="text-gray-300 text-[11px]">{badge.description}</p>
            <span className={`inline-block mt-1 px-1.5 py-0.5 rounded text-[10px] font-medium ${tier.bgColor} ${tier.color}`}>
              {tier.label}
            </span>
            {locked && (
              <p className="text-amber-400 text-[10px] mt-1">
                <i className="ri-lock-line mr-1"></i>{badge.requirement}
              </p>
            )}
          </div>
          <div className="w-2 h-2 bg-gray-900 rotate-45 mx-auto -mt-1"></div>
        </div>
      )}
    </div>
  )
}

export default UserBadge
